export default {"src":"/_next/static/media/WalletMoney.6b3ce745.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};